/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/common';
import ReactSlick from 'react-slick';
import _ from 'lodash';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './TestimonialPane.scss';

class TestimonialPane extends Component {
  constructor(props) {
    super(props);

    this.testimonialsPaneSliderRef = React.createRef();

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  next() {
    if (_.has(this.testimonialsPaneSliderRef, 'current')) {
      this.testimonialsPaneSliderRef.current.slickNext();
    }
  }

  previous() {
    if (_.has(this.testimonialsPaneSliderRef, 'current')) {
      this.testimonialsPaneSliderRef.current.slickPrev();
    }
  }

  render() {
    const { testimonials } = this.props;
    const settings = {
      dots: true,
      lazyLoad: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7000,
    };

    return (
      <div className="testimonial-pane">
        <div className="quote-icon">
          <Icon className="quote-icon-img" name="quote" xLarge />
        </div>
        <div className="testimonial-content-wrapper">
          <ReactSlick
            ref={this.testimonialsPaneSliderRef}
            {...settings}
          >
            {
              testimonials.map((item, idx) => (
                // eslint-disable-next-line
                <div  key={idx} className="testimonial-content">
                  <div className="message">
                    <span>{item.quote}</span>
                  </div>
                  <div className="author-image">
                    <img src={item?.image?.url} alt={item?.imageAlt} />
                  </div>
                </div>
              ))
            }
          </ReactSlick>
          <span
            className="swift-arrow-wrapper left"
            onClick={this.previous}
          >
            <Icon name="arrow_backward" />
          </span>
          <span
            className="swift-arrow-wrapper right"
            onClick={this.next}
          >
            <Icon name="arrow_forward" />
          </span>
        </div>
      </div>
    );
  }
}

TestimonialPane.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    imageAlt: PropTypes.string.isRequired,
    quote: PropTypes.string.isRequired,
  })),
};

TestimonialPane.defaultProps = {
  testimonials: [],
};

export default TestimonialPane;
